import { useAppSelector } from '@/lib/hooks';
import { setDocumentFilterTime } from '@/lib/state/slices/ProjectStateSlice';
import { Popover, Portal, Stack, Text } from '@chakra-ui/react';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import { toaster } from '../ui/toaster';

import 'react-datepicker/dist/react-datepicker.css';
import { useDispatch } from 'react-redux';
import { useSystemTheme } from '@/lib/ThemeSwitcher';

// Returns the date, but in a safe way. If its null, it will return a default value
function safeDate(
  date: Date | number | string | null,
  fallback?: Date | string | number | null,
): Date {
  if (!date) {
    if (fallback) {
      return new Date(fallback);
    }
    return new Date();
  }
  return new Date(date);
}

export default function DateRangeSelector() {
  const timeFilter = useAppSelector((state) => state.viewReducer.documents.filter.timeFilter);
  const dispatch = useDispatch();
  // const { system } = useSystemTheme();

  const [startDatePickerOpen, setStartDatePickerOpen] = useState(false);
  const [endDatePickerOpen, setEndDatePickerOpen] = useState(false);
  return (
    <Stack direction={'row'} gap={0} width={'100%'}>
      <Popover.Root
        open={startDatePickerOpen}
        onOpenChange={(event: { open: boolean }) => {
          setStartDatePickerOpen(event.open);
        }}
      >
        <Popover.Trigger
          style={{ flex: 1 }}
          _hover={{ bg: 'cardHover', transition: 'background-color 0.2s' }}
          backgroundColor="midCardBG"
          borderLeftRadius="0.375rem"
        >
          <div
            style={{
              flex: 1,
              cursor: 'pointer',
              padding: 10,
              // borderColor: //system.tokens.getVar('colors.textOnLight'),
            }}
            onClick={() => {
              setStartDatePickerOpen(true);
            }}
          >
            <Text color="secondaryText" as={'b'} fontSize={'16px'}>
              {safeDate(timeFilter?.lower, '1949').toLocaleDateString()}
            </Text>
          </div>
        </Popover.Trigger>
        <Portal>
          <Popover.Positioner>
            <Popover.Content width="auto" backgroundColor="cardDefault">
              <DatePicker
                inline
                showPopperArrow
                showFullMonthYearPicker
                showYearDropdown
                // css={{
                //   backgroundColor="red"
                // }}
                selected={safeDate(timeFilter?.lower, '1949')}
                onSelect={(date: Date | null) => {
                  if (date) {
                    if (date < safeDate(timeFilter?.upper)) {
                      dispatch(
                        setDocumentFilterTime({
                          lower: date.getTime(),
                          upper: safeDate(timeFilter?.upper).getTime(),
                        }),
                      );
                      setStartDatePickerOpen(false);
                    } else {
                      toaster.create({
                        title: 'Invalid Date',
                        description: 'Start date must be before end date',
                        type: 'error',
                        duration: 3000,
                        closable: true,
                      });
                    }
                  }
                }}
              />
            </Popover.Content>
          </Popover.Positioner>
        </Portal>
      </Popover.Root>

      <Popover.Root
        open={endDatePickerOpen}
        onOpenChange={(event: { open: boolean }) => {
          setEndDatePickerOpen(event.open);
        }}
      >
        <Popover.Trigger
          style={{ flex: 1 }}
          color="secondaryText"
          _hover={{ bg: 'cardHover', transition: 'background-color 0.2s' }}
          backgroundColor="midCardBG"
          borderRightRadius="0.375rem"
        >
          <div
            style={{
              cursor: 'pointer',
              padding: 10,
            }}
            onClick={() => {}}
          >
            <Text color="secondaryText" as={'b'} fontSize={'16px'}>
              {safeDate(timeFilter?.upper).toLocaleDateString()}
            </Text>
          </div>
        </Popover.Trigger>
        <Portal>
          <Popover.Positioner>
            <Popover.Content width="auto">
              <DatePicker
                inline
                showPopperArrow
                showFullMonthYearPicker
                showYearDropdown
                selected={safeDate(timeFilter?.upper)}
                onSelect={(date: Date | null) => {
                  if (date) {
                    if (date > safeDate(timeFilter?.lower, '1949')) {
                      dispatch(
                        setDocumentFilterTime({
                          lower: safeDate(timeFilter?.lower).getTime(),
                          upper: date.getTime(),
                        }),
                      );
                      setEndDatePickerOpen(false);
                    } else {
                      toaster.create({
                        title: 'Invalid Date',
                        description: 'End date must be after start date',
                        type: 'error',
                        duration: 3000,
                        closable: true,
                      });
                    }
                  }
                }}
              />
            </Popover.Content>
          </Popover.Positioner>
        </Portal>
      </Popover.Root>
    </Stack>
  );
}
